export default "__VITE_ASSET__TzeSxzOf__"